import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/Images/logo02.png'


const _hoisted_1 = { class: "contact-realtors" }
const _hoisted_2 = { class: "container-fixed" }
const _hoisted_3 = {
  class: "modal fade",
  id: "modalProducts",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "modal-dialog modal-xl" }
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("video", {
  src: "http://api.realtortools.org/uploads/Video-Residential.mp4",
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("video", {
  src: "http://api.realtortools.org/uploads/Video-Investment.mp4",
  class: "tw-w-full",
  controls: "",
  autoplay: ""
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "contact-realtors__navbar" }
const _hoisted_15 = { class: "navbar navbar-expand-lg d-flex justify-content-between tw-bg-[#fff]" }
const _hoisted_16 = {
  class: "collapse navbar-collapse d-flex justify-content-between",
  id: "navbarTogglerDemo01"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_18 = { class: "form-inline my-2 my-lg-0" }
const _hoisted_19 = { class: "navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center" }
const _hoisted_20 = { class: "nav-item active pr-4" }
const _hoisted_21 = { class: "nav-item active pr-4" }
const _hoisted_22 = { class: "nav-item active pr-4 tw-relative" }
const _hoisted_23 = { class: "dropdown tw-block tw-relative" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  class: "tw-bg-white tw-text-[#606060] tw-flex tw-justify-between tw-w-[150px] tw-items-center",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" PRODUCTS "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-caret-down tw-pb-0.5" })
], -1)
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = { class: "nav-item dropdown" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdownMenuLink",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " SIGN UP ", -1)
const _hoisted_29 = {
  class: "dropdown-menu",
  "aria-labelledby": "navbarDropdownMenuLink"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "contact-realtors__form-contact tw-relative tw-pt-14" }
const _hoisted_32 = { class: "contact-realtors__form-contact__title tw-absolute" }
const _hoisted_33 = {
  key: 0,
  class: "tw-text-[#00a0da] tw-font-semibold tw-text-[30px]"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pb-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#00a0da] tw-text-[32px]" }, "Thank you for contacting us!"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#606060] tw-text-[25px]" }, "We will contact you soon")
], -1)
const _hoisted_35 = { class: "contact-form tw-pb-[100px]" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { for: "email" }
const _hoisted_38 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_39 = { class: "form-group tw-mt-4" }
const _hoisted_40 = { for: "phone" }
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = { class: "form-group tw-mt-4" }
const _hoisted_43 = { for: "direccion" }
const _hoisted_44 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_45 = { class: "form-group tw-mt-4" }
const _hoisted_46 = { for: "direccion" }
const _hoisted_47 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_48 = { class: "form-group tw-mt-4" }
const _hoisted_49 = { for: "mensaje" }
const _hoisted_50 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_51 = { class: "tw-pt-8 tw-flex tw-pb-[60px]" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "footer-realtors" }
const _hoisted_54 = { class: "container-fixed" }
const _hoisted_55 = { class: "row w-100" }
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<div class=\"img-brand col-xs-12 col-sm-12 col-md-3\"><img src=\"" + _imports_0 + "\" alt=\"\"></div><div class=\"contact col-xs-12 col-sm-12 col-md-3\"><ul class=\"\"><li class=\"tw-pb-3\"><a href=\"#\" class=\"fs-4 tw-font-semibold\">Contact</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/realtor\" class=\"tw-font-normal tw-text-[#dfdede] tw-ml-5\">Related to Realtor</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/mlo\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to MLO</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/title-company\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Title Company</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"/contact/inspector\" class=\"tw-text-[#dfdede] tw-ml-5\">Related to Inspectors</a></li></ul></div>", 2)
const _hoisted_58 = { class: "documents col-xs-12 col-sm-12 col-md-3" }
const _hoisted_59 = { class: "" }
const _hoisted_60 = { class: "tw-mb-4 tw-pt-3 fs-5 tw-font-semibold" }
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/REALTORTOLLS-POLICY-ENGLISH.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Privacy Policy</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/TERMS-AND-USES.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Terms of use</a></li><li class=\"tw-mb-4 tw-pt-3\"><a href=\"https://www.realtortools.org/media/COPYRIGHT-HOME.pdf\" class=\"fs-5 tw-font-semibold\" target=\"_blank\">Copyright</a></li>", 3)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, "© 2023 SOURCE RealtorTools, PBC. All rights reserved. Terms of Use | Privacy Policy Patents")
  ])
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "visible-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-realtors__section5__copyright pb-5" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("© 2023 SOURCE RealtorTools, PBC. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" All rights reserved. "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Terms of Use | Privacy Policy Patents")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_routerLink = _resolveComponent("routerLink")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": _ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              (_ctx.productSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_ctx.productSelected.toString() == '1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.productSelected.toString() == '2')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("nav", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("form", _hoisted_18, [
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", _hoisted_20, [
                    _createVNode(_component_routerLink, { to: "/" }, {
                      default: _withCtx(() => [
                        _createTextVNode("HOME")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _createVNode(_component_routerLink, { to: "/target" }, {
                      default: _withCtx(() => [
                        _createTextVNode("TARGET")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_22, [
                    _createElementVNode("a", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("ul", _hoisted_25, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('modalProducts', '1')))
                          }, "RESIDENTIAL")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "#",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('modalProducts', '2')))
                          }, "INVESTMENT")
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _createVNode(_component_routerLink, { to: "/loginusers" }, {
                      default: _withCtx(() => [
                        _createTextVNode("LOG IN ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("ul", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRoles, (role) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (role.name != 'ADMIN')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                id: "option",
                                href: '/register?type=' + role.idRole
                              }, _toDisplayString(role.name), 9, _hoisted_30))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          (_ctx.formContact.role)
            ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.formContact.role.name.toUpperCase()), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitContactForm && _ctx.submitContactForm(...args)), ["prevent"])),
            class: "centered-form tw-bg-white tw-pr-14 tw-pl-14 tw-pt-10 tw-rounded-[20px]"
          }, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, [
                _createTextVNode("EMAIL"),
                (_ctx.v$.formContact.email.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                id: "email",
                class: "form-control small-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.formContact.$model.email) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.v$.formContact.$model.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("label", _hoisted_40, [
                _createTextVNode("PHONE"),
                (_ctx.v$.formContact.phone.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "tel",
                id: "phone",
                class: "form-control small-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.formContact.$model.phone) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.v$.formContact.$model.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, [
                _createTextVNode("FIRST NAME"),
                (_ctx.v$.formContact.firstname.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "direccion",
                class: "form-control small-input",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.formContact.$model.firstname) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.v$.formContact.$model.firstname]
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, [
                _createTextVNode("LAST NAME"),
                (_ctx.v$.formContact.lastname.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "direccion",
                class: "form-control small-input",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.formContact.$model.lastname) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.v$.formContact.$model.lastname]
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("label", _hoisted_49, [
                _createTextVNode("MESSAGE"),
                (_ctx.v$.formContact.message.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                id: "mensaje",
                class: "form-control",
                rows: "4",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.formContact.$model.message) = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.v$.formContact.$model.message]
              ])
            ]),
            _withDirectives(_createVNode(_component_vue_recaptcha, {
              class: "tw-pt-8",
              sitekey: "6LeltwIoAAAAAFi7XHaVN10KmlP3byX2HatfvLCE",
              size: "normal",
              theme: "light",
              "loading-timeout": 3000,
              onExpire: _ctx.recaptchaExpired,
              onVerify: _ctx.recaptchaVerified,
              ref: "vueRecaptcha"
            }, null, 8, ["onExpire", "onVerify"]), [
              [_vShow, true]
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "submit",
                disabled: !_ctx.recaptchaResponse || _ctx.v$.formContact.$invalid,
                class: "btn btn-primary tw-bg-[#00a0da] tw-border-[#00a0da] tw-rounded-full tw-pl-5 tw-pr-5 tw-font-semibold tw-cursor-pointer"
              }, "SUBMIT", 8, _hoisted_52)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("ul", _hoisted_59, [
              _createElementVNode("li", _hoisted_60, [
                _createVNode(_component_routerLink, { to: "/faqs" }, {
                  default: _withCtx(() => [
                    _createTextVNode("FAQs")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_61
            ])
          ])
        ]),
        _hoisted_64,
        _hoisted_65,
        _hoisted_66
      ])
    ])
  ], 64))
}